module.exports = __webpack_public_path__ + "img/symbol_7.a50878a1.png";